/**
 * Removes keys with null or undefined values from a work item attributes object.
 * Ensures optional fields left blank by the user are omitted from the API payload
 * rather than sent as null, which would trigger type validation errors.
 */
export const stripNullAttributes = (
  attributes: Record<string, any>
): Record<string, any> =>
  Object.fromEntries(
    Object.entries(attributes).filter(
      ([, value]) => value !== null && value !== undefined
    )
  );
